<template>
  <div class="auditFailReason">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :before-close="close"
    >
      <template v-if="type === '1'">
        <el-table border v-loading="loading" :data="data" style="width: 100%">
          <el-table-column width="300px" label="操作时间" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.insertDate || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="教务服务方" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.companyName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拒绝合作原因" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.reason || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-else-if="type === '2'">
        <el-table border v-loading="loading" :data="data" style="width: 100%">
          <el-table-column width="300px" label="操作时间" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.insertDate || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核驳回原因" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.reason || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- 分页 -->
      <!-- <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      /> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyRejectReasonListPage } from "@/api/organization";
// import myPagination from "@/components/myPagination.vue";
export default {
  // components: {
  //   myPagination,
  // },
  data() {
    return {
      loading: false,
      dialogTitle: "",
      dialogVisible: false,
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      type: "",
      licenseNum: "",
    };
  },
  methods: {
    // 初始化
    init(type, licenseNum) {
      this.type = type;
      this.licenseNum = licenseNum;
      this.dialogTitle = type === "1" ? "拒绝合作原因" : "审核驳回原因";
      this.getCompanyRejectReasonListPage({ page: 1, limit: -1 });
      this.dialogVisible = true;
    },
    // 刷新
    refresh() {
      this.getCompanyRejectReasonListPage({
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
      });
    },
    // 列表请求
    async getCompanyRejectReasonListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getCompanyRejectReasonListPage({
        ...payload,
        type: this.type,
        licenseNum: this.licenseNum,
      });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCompanyRejectReasonListPage({
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCompanyRejectReasonListPage({ page: 1, limit: payload });
    },
  },
};
</script>

<style lang="scss" scoped>
.auditFailReason {
}
</style>
